/**
 * Extrait les dernières entrées de mouvement qui ne sont pas de type "simulation"
 * pour chaque véhicule sélectionné
 * @param {Array} flotteList - Liste complète des véhicules
 * @param {Set} selectedRowsIds - Set des IDs des véhicules sélectionnés
 * @returns {Array} Données de simulation en masse
 */
export const generateSimulationEnMasseData = (flotteList, selectedRowsIds) => {
  const simulationData = [];

  // Pour chaque véhicule sélectionné
  selectedRowsIds.forEach((vehicleId) => {
    const vehicle = flotteList.find((item) => item.id === vehicleId);

    if (!vehicle || !vehicle.mouvements || !Array.isArray(vehicle.mouvements)) {
      console.warn(`Véhicule ${vehicleId} non trouvé ou sans mouvements`);
      return;
    }

    // Filtrer les mouvements qui ne sont pas de type "simulation"
    const nonSimulationMovements = vehicle.mouvements.filter(
      (mouvement) =>
        mouvement.type !== "simulation" &&
        mouvement.type !== "simulation_prorata_km",
    );

    if (nonSimulationMovements.length === 0) {
      console.warn(
        `Aucun mouvement non-simulation trouvé pour le véhicule ${vehicleId}`,
      );
      return;
    }

    // Prendre le dernier mouvement non-simulation (le plus récent)
    const lastMovement =
      nonSimulationMovements[nonSimulationMovements.length - 1];

    simulationData.push({
      vehicleId: vehicle.id,
      vehicleInfo: {
        marque: vehicle.identification?.marque,
        modele: vehicle.identification?.modele,
        immatriculation: vehicle.identification?.immatriculation,
        client: vehicle.contrat?.intitule_client,
      },
      lastMovement,
      mouvements: vehicle.mouvements,
      km_reel: vehicle.km_reel,
    });
  });

  return simulationData;
};
